<template>
  <div class="containerMod">
    <div class="Blk-SelEst">
      <select class="estadoHead" name="estados" id="" v-model="estadoSel" required label= "Selecciona un estado">
        <option value="" disabled selected>Selecciona un estado</option>
        <option v-for="(estado, index) in estados"
          :key="index"
          :value="estado">
          {{estado.estado}}
        </option>
      </select>
      <div class="Blk-Btn-Cat">
        <div class="btn-sort" :class="Lon" @click="ordenaLon">&longleftrightarrow;</div>
        <div class="btn-sort" :class="Des" @click="ordenaDes">&UpDownArrow;</div>
        <div class="btn-sort" :class="Nat" @click="ordenaNat">Aa.1</div>
      </div>
    </div>
    <div class="lista">
      <div v-if="loading" class="loading-container">
        <div class="loader"></div>
      </div>
      <div v-else>
        <div class="bloqueFicha" v-for="cueva in filtroEstados" :key="cueva._id">
            <div class="eti">
              <div class="abreviatura">{{cueva.abrEst + ' ' + cueva.numCat}}</div>
              <div class="datos1">{{'Desarrollo ' + cueva.desarrollo + ' m'}}</div>
              <div class="datos2">{{'Desnivel ' + cueva.desnivel + ' m'}}</div>
              <div class="datos1Cel">{{'&LeftRightArrow;  ' + cueva.desarrollo + ' m'}}</div>
              <div class="datos2Cel">{{'&UpDownArrow;  ' + cueva.desnivel + ' m'}}</div>
            </div>
            <!-- <div class="editor">{{libro.ciudad}}</div>
            <div class=""></div>
            <div class="nombre">{{libro.titulo}}</div>
            <div></div> -->
            <div class="contenido">
              <div class="linea1">
                {{cueva.nombre}}
              </div>
              <div class="linea2">
                {{cueva.zonaCarstica}}
              </div>
              <div class="linea3">
                {{cueva.localizacion}}
              </div>
              <div class="boletin">
                {{'Publicada en el BSVE: ' + cueva.boletin}}
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import estados from '@/assets/JSON/estados.json'
export default {
  name: 'ShowCatastro',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.getCatastro()
    this.estados = estados
    this.$emit('scrollHidden')
  },
  emits: ['scrollHidden', 'NoScrollHidden'],
  data () {
    return {
      catastro: [],
      estados: [],
      URLbase: '',
      estadoSel: { estado: '<Todos los estados>', Abr: '0' },
      arrayFiltroOrden: [],
      loading: false,
      orden: 0
    }
  },
  methods: {
    async getCatastro () {
      try {
        this.loading = true
        const url = `${this.URLbase}/cuevas/catastro`
        axios.post(url)
          .then(result => {
            const catastro = result.data
            this.catastro = catastro
            this.loading = false
          })
          .catch(error => {
            console.log(error)
            this.loading = false
          })
      } catch (error) {
        alert(error)
        this.loading = false
      }
    },
    ordenaLon () {
      this.orden = 1
    },
    ordenaDes () {
      this.orden = 2
    },
    ordenaNat () {
      this.orden = 0
    },
    comparaLon (a, b) {
      if (a.desarrollo > b.desarrollo) {
        return -1
      }
      if (a.desarrollo < b.desarrollo) {
        return 1
      } else {
        return 0
      }
    },
    comparaDes (a, b) {
      if (a.desnivel > b.desnivel) {
        return -1
      }
      if (a.desnivel < b.desnivel) {
        return 1
      } else {
        return 0
      }
    }
  },
  computed: {
    Lon () {
      let a = ''
      if (this.orden === 1) {
        a = 'botonPulsado'
      }
      return a
    },
    Des () {
      let a = ''
      if (this.orden === 2) {
        a = 'botonPulsado'
      }
      return a
    },
    Nat () {
      let a = ''
      if (this.orden === 0) {
        a = 'botonPulsado'
      }
      return a
    },
    filtroEstados () {
      let result = []
      if (this.estadoSel.estado === '<Todos los estados>') {
        switch (this.orden) {
          case 0:
            result = this.catastro
            break
          case 1:
            result = this.catastro.filter(c => c.abrEst !== '').sort(this.comparaLon)
            break
          case 2:
            result = this.catastro.filter(c => c.abrEst !== '').sort(this.comparaDes)
            break
        }
      } else {
        switch (this.orden) {
          case 0:
            result = this.catastro.filter(c => c.abrEst === this.estadoSel.Abr)
            break
          case 1:
            result = this.catastro.filter(c => c.abrEst === this.estadoSel.Abr).sort(this.comparaLon)
            break
          case 2:
            result = this.catastro.filter(c => c.abrEst === this.estadoSel.Abr).sort(this.comparaDes)
            break
        }
      }
      return result
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.containerMod{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 100%;
}
.Blk-SelEst{
  display: flex;
  /* border: solid 0.5px rgb(76, 248, 2); */
  height: 8%;
  justify-content:flex-end;
  align-items: center;
  background-color: var(--gr-fo-for);
  margin-top: 3px;
}
.estadoHead{
  height: 78%;
  width: 30%;
  border: var(--bo-cam);
  border-radius: 3px;
  color: var(--tx-cam);
  font-weight: 600;
  font-size: 16px;
  margin-left: 3.2%;
}
.Blk-Btn-Cat{
  display:flex;
  height: 70%;
  margin-right: 5%;
  margin-bottom: 2px;
  /* border: solid 0.5px rgb(76, 248, 2); */
  /* width: 42%; */
}
.btn-sort{
  height: 100%;
  aspect-ratio: 1;
  margin-left: 6px;
  margin-bottom: 2px;
  background-color: rgb(38, 185, 205);
  border-radius: 3px;
  border: solid 1px rgb(69, 158, 181);
  font-weight: 600;
  line-height: 180%;
  font-size: 94%;
}
.btn-sort:hover {
  transform: scale(1.06);
  cursor: pointer
}
.botonPulsado{
  background-color: rgb(3, 138, 179);
}
.lista {
  overflow-y: scroll;
  height: 100%;
  width: 100%;
  margin-top: 3px;
  background-color: var(--gr-fo-for);
  color:rgb(2, 2, 2);
  /* border: solid 0.5px rgb(235, 3, 247); */
}
.nombre{
  font-family: SegoeBI;
  color: black;
  padding: 4px;
}
.bloqueFicha{
  margin-top: 10px;
  padding-bottom: 1px;
  display: grid;
  grid-template-columns: 24% 70%;
}
.abreviatura{
  font-size: 105%;
  font-weight: 800;
  color: rgb(30, 119, 161);
  background-color: white;
  border: solid 1px gray;
  box-shadow: none;
  margin: 0px 12%;
  padding-bottom:2px;
}
.datos1{
  font-size: 80%;
  color: white;
  background-color: rgb(82, 120, 195);
  margin: 3px 12%;
  padding-bottom:3px;
  padding-top:1px;
}
.datos2{
  font-size: 80%;
  color: white;
  background-color: rgb(49, 72, 118);
  margin: 0px 12%;
  padding-bottom:4px;
  padding-top:1px;
}
.datos1Cel, .datos2Cel{
  display: none;
}
.contenido{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
  border-bottom: solid 0.5px rgb(136, 166, 180);
  padding-bottom: 25px;
  margin-bottom: 0px;
}
.linea1{
  text-align: left;
  font-weight: bold;
  font-size: 16px;
  color: rgb(30, 119, 161);
}
.linea2{
  font-size: 14px;
  font-weight:700;
}
.linea3{
  font-size: 14px;
  text-align: left;
}
.boletin{
  font-size: 13px;
  text-align: left;
  font-weight:700;
  color: rgb(114, 113, 113);
  padding-top: 3px
}
.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader {
  border: 4px solid transparent;
  border-top-color: #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 576px){
  .Blk-SelOrd{
    display: flex;
    width: 100%;
  }
  .bloqueFicha{
    grid-template-columns: 26% 72%;
    /* background-color: var(--gr-fo-for); */
    border-bottom: solid 0.5px rgb(136, 166, 180);
  }
  .eti{
    justify-self: center;
    width: 80%;
    /* border: solid .5px rgb(250, 135, 4); */
  }
  .contenido{
    /* border: solid .5px rgb(250, 135, 4); */
    padding-left: 0;
    border-bottom: none;
  }
  .abreviatura{
    width: 100%;
    font-size: 105%;
    font-weight: 800;
    color: rgb(30, 119, 161);
    background-color: white;
    border: solid 1px gray;
    box-shadow: none;
    margin: 0;
    padding-bottom:2px;
  }
  .datos1, .datos2{
    display: none;
  }
  .datos1Cel, .datos2Cel{
    display: block;
    border-radius: 0;
    color:black;
    background-color: none;
    margin-top:5px;
  }
  .linea1, .linea2, .linea3, .linea4, .boletin{
    text-align: left;
    padding-left: 10px;
    padding-right: 15px;
  }
  .linea2{
    /* font-size: 14px; */
    margin-top: 6px;
    font-weight: 800;
  }
  .containerEdiciones{
    width: 90%;
  }
  .bloqueEdicion{
    display: flex;
    flex-direction: column;
  }
  .up, .down{
    margin:  2px 4px 0;
  }

  .Blk-SelEst{
    width: 100vw;
    justify-content:center;
    background-color: rgb(166, 170, 172,0.9);
  }
  .estadoHead{
    height: 66%;
    width: 70vw;
    color: var(--tx-cam);
    font-size: 16px;
    margin-left: 8px;
  }
  .Blk-Btn-Cat{
    display:flex;
    height: 70%;
    margin-left: 2%;
    width: 40%;
  }
  .btn-sort{
    height: 100%;
    aspect-ratio: 1;
    margin-left: 6px;
    margin-bottom: 0;
    background-color: rgb(38, 185, 205);
    border-radius: 3px;
    border: solid 1px rgb(69, 158, 181);
    font-weight: 600;
    line-height: 200%;
    font-size: 95%;
  }
  .botonPulsado{
    background-color: rgb(3, 138, 179);
  }
}
@media screen and (max-width: 370px){
  .btn-sort{
    line-height: 170%;
    font-size: 85%;
  }
  .botonPulsado{
    background-color: rgb(3, 138, 179);
  }
}
</style>
